export default {"src":"/_next/static/media/rmhpss.61455692.svg","height":500,"width":500};